import React, { useEffect, useState } from "react";
import {
  House,
  Plus,
  ClipboardList,
  ListChecks,
  Gift,
  Settings,
  Timer,
  ArrowRight,
  Wallet,
  Menu,
  X
} from "lucide-react";

import star from "../assets/img/star.svg";
import crown from "../assets/img/crown.svg";
import userimg from "../assets/img/user-img.png";
import dollar from "../assets/img/dollar.svg";
import fire from "../assets/img/fire.svg";
import { Link } from "react-router-dom";
import userone from "../assets/img/user1.jpg";
import photolg from "../assets/img/photo-1.jpg";







const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1200) {
        setSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (window.innerWidth < 1200 && sidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [sidebarOpen]);

  return (
    <div className="dashboard-page">
     

      {/* ================= MAIN SECTION ================= */}
      <section className="pt60px">
        <div className="container-fluid">
          <div className="row dashboard-layout">

            <div
              className={`dashboard-sidebar-backdrop ${sidebarOpen ? "show" : ""}`}
              onClick={() => setSidebarOpen(false)}
            ></div>

            {/* ================= LEFT SIDEBAR ================= */}
            <div className={`col-xl-3 col-md-4 col-12 mb-4 rightslidebar ${sidebarOpen ? "sidebar-open" : ""}`}>

              <div className="d-flex align-items-center justify-content-between mb-4 d-xl-none dashboard-sidebar-close">
                <h4 className="fw-bold mb-0">Dashboard Menu</h4>
                <button
                  type="button"
                  className="btn btn-dark rounded-circle p-2"
                  onClick={() => setSidebarOpen(false)}
                  aria-label="Close dashboard menu"
                >
                  <X size={18} />
                </button>
              </div>

              {/* Profile Card */}
              <div className="sidebar-card mb-4 text-center">

                <img
                  src={userone} alt="userone"
                  className="user-img mb-3 mx-auto"
                />

                <h2 className="fw-bold ft-22 mb-2">Alex Rivera</h2>

                <div className="active-badge ft-12 fw-bold">
                  ● Active Explorer
                </div>

                <hr className="my-4" />

                <div className="row user-stats text-center">
                  <div className="col-4">
                    <h4>128</h4>
                    <p>Posts</p>
                  </div>

                  <div className="col-4">
                    <h4>4.8k</h4>
                    <p>Followers</p>
                  </div>

                  <div className="col-4">
                    <h4>312</h4>
                    <p>Following</p>
                  </div>
                </div>

              </div>

              {/* Menu Card */}
              <div className="menu-card">

                <a href="/" className="menu-link active">
                  <House size={22} />
                  Dashboard
                </a>

                <a href="/" className="menu-link">
                  <Plus size={22} />
                  Create Survey
                </a>

                <a href="/" className="menu-link">
                  <ClipboardList size={22} />
                  My Surveys
                </a>

                <a href="/" className="menu-link">
                  <ListChecks size={22} />
                  Surveys For Me
                </a>

                <a href="/" className="menu-link">
                  <Gift size={22} />
                  Rewards Points
                </a>

                <a href="/" className="menu-link">
                  <Settings size={22} />
                  Settings
                </a>

              </div>


               <div className="coin-card position-relative overflow-hidden">

                    {/* Glow Effects */}
                    <div className="glow glow-top"></div>
                    <div className="glow glow-bottom"></div>

                    {/* Icon */}
                    <div className="wallet-icon"><Wallet size={22} strokeWidth={2.2} /></div>

                    {/* Content */}
                    <h6 className="ft-13 fw-semibold mb-3">Available Balance</h6>

                    <h1 className="coin-title fw-bold mb-4">100 Coins</h1>

                    <p className="coin-desc">Use coins to boost surveys & unlock premium actions.</p>

                    {/* Button */}
                    <button className="buy-btn w-100 fw-bold">Buy Coins</button>

                    {/* Footer */}
                    <Link to="/" className="wallet-history d-flex align-items-center justify-content-center gap-2 mt-4">
                        <span>View wallet history</span> <ArrowRight size={18} />
                    </Link>

                </div>


            </div>

            {/* ================= CENTER SECTION ================= */}
            <div className="col-xl-6 col-md-8 col-12 mb-4 leftslidebar">

              <div className="dashboard-sidebar-trigger d-xl-none mb-4">
                <button
                  type="button"
                  className="btn btn-dark ft-15 fw-600 d-flex align-items-center gap-2"
                  onClick={() => setSidebarOpen(true)}
                >
                  <Menu size={18} />
                  <span>Open Profile</span>
                </button>
              </div>

              <div className="post-card mb-4">

                {/* User */}
                <div className="d-flex align-items-center mb-3">
                  <img
                    src={userimg}
                    alt=""
                    className="post-user-img"
                  />

                  <div className="ms-3">
                    <h5 className="ft-15 fw-bold mb-1">
                      Aisha Mehta
                    </h5>

                    <p className="ft-12 mb-0">
                      Product Researcher - 18 Min Ago
                    </p>
                  </div>
                </div>

                {/* Banner */}
                <div className="position-relative mb-4">

                  <img
                    src={photolg}
                    alt="photolg"
                    className="post-banner"
                  />

                  <div className="reward-badge ft-11 d-flex gap-2 align-items-center">
                    <img src={star} alt="star" /> Reward: 25 Coins
                  </div>

                </div>

                {/* Content */}
                <h2 className="post-title fw-bold mb-3 ft-20">
                  How Do Remote Teams Choose Async Collaboration Tools?
                </h2>

                <p className="post-desc ft-12 mb-3">
                  Help map what drives adoption across startups and distributed
                  product teams. Results will be shared with the community this week.
                </p>

                {/* Tags */}
                <div className="d-flex flex-wrap gap-2 mb-4">

                  <span className="tag-box">
                    #Technology
                  </span>

                  <span className="tag-box">
                    #SaaS
                  </span>

                  <span className="tag-box">
                    #Workplace
                  </span>

                </div>

                {/* Time */}
                <div className="d-flex flex-wrap gap-2 mb-4 ft-13 color858c95">
                    <Timer size={20} /> 5 mins
                </div>

                

                {/* Footer */}
                <div className="post-footer d-flex justify-content-between align-items-center flex-wrap gap-3">

                  <div className="d-flex align-items-center gap-3">

                    <div className="icon-btn">
                      <i className="bi bi-share"></i>
                    </div>

                    <div className="icon-btn">
                      <i className="bi bi-bookmark"></i>
                    </div>

                  </div>

                  <button className="eligibility-btn ft-15 text-white px-5 py-3 bgred rounded-3 hover:tw-bg-[#333] tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-scale-105">
                    Check your eligibility
                  </button>

                </div>

              </div>

              <div className="post-card mb-4">

                {/* User */}
                <div className="d-flex align-items-center mb-3">
                  <img
                    src={userone}
                    alt=""
                    className="post-user-img"
                  />

                  <div className="ms-3">
                    <h5 className="ft-15 fw-bold mb-1">
                      Aisha Mehta
                    </h5>

                    <p className="ft-12 mb-0">
                      Product Researcher - 18 Min Ago
                    </p>
                  </div>
                </div>

                {/* Banner */}
                <div className="position-relative mb-4">

                  <img
                    src={photolg}
                    alt=""
                    className="post-banner"
                  />

                  <div className="reward-badge ft-11 d-flex gap-2 align-items-center">
                    <img src={star} alt="star" /> Reward: 25 Coins
                  </div>

                </div>

                {/* Content */}
                <h2 className="post-title fw-bold mb-3 ft-20">
                  How Do Remote Teams Choose Async Collaboration Tools?
                </h2>

                <p className="post-desc ft-12 mb-3">
                  Help map what drives adoption across startups and distributed
                  product teams. Results will be shared with the community this week.
                </p>

                {/* Tags */}
                <div className="d-flex flex-wrap gap-2 mb-4">

                  <span className="tag-box">
                    #Technology
                  </span>

                  <span className="tag-box">
                    #SaaS
                  </span>

                  <span className="tag-box">
                    #Workplace
                  </span>

                </div>

                {/* Time */}
                <div className="d-flex flex-wrap gap-2 mb-4 ft-13 color858c95">
                    <Timer size={20} /> 5 mins
                </div>

                

                {/* Footer */}
                <div className="post-footer d-flex justify-content-between align-items-center flex-wrap gap-3">

                  <div className="d-flex align-items-center gap-3">

                    <div className="icon-btn">
                      <i className="bi bi-share"></i>
                    </div>

                    <div className="icon-btn">
                      <i className="bi bi-bookmark"></i>
                    </div>

                  </div>

                  <button className="eligibility-btn ft-15 text-white px-5 py-3 bgred rounded-3 hover:tw-bg-[#333] tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-scale-105">
                    Check your eligibility
                  </button>

                </div>

              </div>

            </div>

            {/* ================= RIGHT SECTION ================= */}
            <div className="col-xl-3 col-md-12 col-12 contributorsbox">

                <div className="right-card mb-4">

                    <h4 className="fw-bold mb-4 d-flex gap-3 align-items-center">
                    <img src={crown} alt="crown" /> Top Contributors
                    </h4>

                    <div className="contributor-item">
                        <div className="d-flex align-items-center">

                            <div className="rank-circle">1</div>

                            <img src={userimg} alt="" className="contributor-img"/>

                            <div>
                            <div className="ft-14 hname fw-semibold">
                                Lena Morris
                            </div>

                            <small className="text-muted hscore ft-12 fw-semibold">
                                3,480 coins - 96 score
                            </small>
                            </div>

                        </div>
                    </div>

                   <div className="contributor-item">
                        <div className="d-flex align-items-center">

                            <div className="rank-circle">2</div>

                            <img src={userimg} alt="" className="contributor-img"/>

                            <div>
                            <div className="ft-14 hname fw-semibold">
                                Arjun Rao
                            </div>

                            <small className="text-muted hscore ft-12 fw-semibold">
                                2,915 coins - 91 score
                            </small>
                            </div>

                        </div>
                    </div>

                    <div className="contributor-item">
                        <div className="d-flex align-items-center">

                            <div className="rank-circle">3</div>

                            <img src={userimg} alt="" className="contributor-img"/>

                            <div>
                                <div className="ft-14 hname fw-semibold">
                                    Sara Kim
                                </div>

                                <small className="text-muted hscore ft-12 fw-semibold">
                                    2,640 coins - 88 score
                                </small>
                            </div>

                        </div>
                    </div>

                </div>

                <div className="right-card mb-4">

                    <h4 className="fw-bold mb-4">
                    Trending Surveys
                    </h4>

                    <div className="w-100 d-flex align-items-center justify-content-between surverystaglist">
                        <div className="d-flex align-items-center gap-2">
                            <div className="surveysname fw-bold ft-13">#Technology</div>
                            <small className="surveysnumber fw-semibold ft-11">2,480 surveys</small>
                        </div>
                        <div className="surveygrowth ft-12">+18%</div>
                    </div>

                    <div className="w-100 d-flex align-items-center justify-content-between surverystaglist">
                        <div className="d-flex align-items-center gap-2">
                            <div className="surveysname fw-bold ft-13">#Gaming</div>
                            <small className="surveysnumber fw-semibold ft-11">1,942 surveys</small>
                        </div>
                        <div className="surveygrowth ft-12">+15%</div>
                    </div>

                    <div className="w-100 d-flex align-items-center justify-content-between surverystaglist">
                        <div className="d-flex align-items-center gap-2">
                            <div className="surveysname fw-bold ft-13">#AI</div>
                            <small className="surveysnumber fw-semibold ft-11">1,628 surveys</small>
                        </div>
                        <div className="surveygrowth ft-12">+12%</div>
                    </div>

                </div>

                 <div className="right-card mb-4">

                    <h4 className="fw-bold mb-4">Quick Insights</h4>

                    <div className="d-flex align-items-center gap-3 quickbox">
                        <div className="iconbtn">
                            <img src={dollar} alt="dollar"/>
                        </div>

                        <div>
                            <div className="quickname">
                                Weekly Earned
                            </div>

                            <small className="quickno">
                                120 Coins
                            </small>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-3 quickbox">
                        <div className="iconbtn">
                            <img src={fire} alt="fire"/>
                        </div>

                        <div>
                            <div className="quickname">
                                Weekly Earned
                            </div>

                            <small className="quickno">
                                120 Coins
                            </small>
                        </div>
                    </div>

                </div>

                

            </div>

          </div>
        </div>
      </section>

      
    </div>
  );
};

export default Dashboard;
